/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CommitteeMeetingParticipantDto } from './CommitteeMeetingParticipantDto';

export type CommitteeMeetingDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    companyId?: string;
    subject?: string;
    plannedDate?: string;
    isFaceToFace?: boolean;
    description?: string;
    meetingStatusDefinition?: CommitteeMeetingDto.meetingStatusDefinition;
    meetingParticipants?: Array<CommitteeMeetingParticipantDto>;
}

export namespace CommitteeMeetingDto {

    export enum meetingStatusDefinition {
        DONE = 'DONE',
        ABORT = 'ABORT',
        DELAY = 'DELAY',
        PLANNED = 'PLANNED',
    }


}
